import Vue from 'vue'
import { $themeConfig } from '@themeConfig'
import { ticketTimeStore } from '../gql/query'

const { GET_REASON_TICKET_TIME } = ticketTimeStore()

export default {
    fetchReasonTicketTime({ commit }) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .post(`${$themeConfig.app.gqlUrl}`, {
                    query: GET_REASON_TICKET_TIME,
                })
                .then(response => {
                    commit(
                        'SET_REASON_CHANGES',
                        response.data.data.ticket_time_change_reason
                    )
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    getRestaurantById(ctx, id) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(
                    `${$themeConfig.app.backUrlDivisions}/divisions/${id}?mod=logist`
                )
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    insertActualTime(
        ctx,
        { time, typeTime, restaurantRkId, comment, changeReason, sectors }
    ) {
        let request = {}

        if (typeTime === 'cooking_time') {
            request = {
                cooking_time: {
                    value: time,
                    change_reason: changeReason,
                    comment,
                },
            }
        } else {
            request = {
                delivery_time: {
                    change_reason: changeReason,
                    comment,
                    sectors: sectors.map(({ sector_id, delivery_time }) => {
                        return {
                            sector_id,
                            value: delivery_time,
                        }
                    }),
                },
            }
        }

        return new Promise((resolve, reject) => {
            Vue.axios
                .post(
                    `${$themeConfig.app.backUrlDeliveryApiV1}/division/${restaurantRkId}/time`,
                    request
                )
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getActualTime(ctx, restaurantRkId) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(
                    `${$themeConfig.app.backUrlDeliveryApiV1}/division/${restaurantRkId}/time?activeOnly=false`
                )
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getRestaurantsIntervals(ctx, restaurantRkId) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(
                    `${$themeConfig.app.backUrlDeliveryApiV1}/division/${restaurantRkId}/intervals`
                )
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    fetchDivisionTimeChanges({ commit }, { divisionId, limit, offset }) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(
                    `${$themeConfig.app.backUrl}/divisions/${divisionId}/time-changes?limit=${limit}&offset=${offset}`
                )
                .then(response => {
                    commit('ADD_DIVISION_TIME_CHANGES', response.data)
                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}
